import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSingleDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";

declare var ko: any;
declare var dhtmlXCalendarObject: any;
declare var Dropzone: any;

export class dataImport_template extends vnTemplate{

    public filterDate: filterSingleDate_template;
    public datesFilter: filterDate_template;
    public reportFilter: filterDropdown_template;
    public brandsFilter: filterDropdown_template;
    public countriesFilter: filterDropdown_template;
    protected validationsList: validationsList_template;

    protected getTemplateHtml(): string{

        return `
                
            <div class="sub-header w-justify"> 
              
                <div class="w-left">
                    <div><label class="form-label" for="" >Report</label>` + this.reportFilter.getHtmlBuild() + `</div>            
                    
                    <!-- ko if: isBrandFilterEnabled() -->
                    <div>
                        <label class="form-label" for="" >Brand</label>
                        ` + this.brandsFilter.getHtmlBuild() + `
                    </div>   
                    <!-- /ko -->  
                    
                    <div data-bind="visible: isSingleDateFilterEnabled()"><label class="form-label" for="" >Date</label>` + this.filterDate.getHtmlBuild() + `</div>

                    <!-- ko if: showCountries() -->
                    <div>
                        <label class="form-label" for="" >Country</label>
                        ` + this.countriesFilter.getHtmlBuild() + `
                    </div>
                    <!-- /ko -->
                    
                    <div id="dropzone"> 
                        <div id="my-drop-zone" class="dropzone needsclick dz-clickable"></div>
                        <input id="reportPath" data-bind="value: reportPath" type="hidden">
                    </div>
                    <button data-bind="event: { click: onClickImport }, css: {'disable' :  disableImport() }" class="btn highlight icon i-import" type="button">Import Report</button>
                </div>
                
                <div class="w-right flex-none">
                    <a href="https://docs.google.com/spreadsheets/d/1Es4IxotnDM6i3mtM4fqaprRhEpSjsJ4d7JZ4I--MEQA/edit?usp=sharing" class="btn highlight icon i-sheet" target="_blank">report format examples</a>
                </div>
                
            </div>
  
            <div class="list-header w-justify">  
                <div class="w-left">
                    <h2 class="section-title icon i-data">Data Import</h2>
                 </div>
            </div>
            `;
    }

    protected initPartial():void{
        this.filterDate = new filterSingleDate_template( "filterDate", this.getTemplateViewModel(), this.caller );

        this.reportFilter = new filterDropdown_template("reportFilter", this.getTemplateViewModel(), this.caller)

        this.brandsFilter = new filterDropdown_template("brandsFilter", this.getTemplateViewModel(), this.caller)

        this.countriesFilter = new filterDropdown_template("countriesFilter", this.getTemplateViewModel(), this.caller)

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){

            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{

            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);
    }
    protected getTemplateName(): string{
        return "data_import-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return [];
    }

    protected buildViewModel(): any{
        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return  {
            reportPath: ko.observable(null),
            countryList: ko.observableArray([]),
            onClickImport: function(data, event){ huit_neuf_this.onClickImport(); },
            disableImport: function(data){return ko.computed(function () { return huit_neuf_this.disableImport();}, this)},
            isFileUploadMissing: function(data){return ko.computed(function () { return huit_neuf_this.isFileUploadMissing();}, this)},
            isReportFilterMissing: function(data){return ko.computed(function () { return huit_neuf_this.isReportFilterMissing();}, this)},
            showCountries: function(data){return ko.computed(function () { return huit_neuf_this.showCountries();}, this)},
            isBrandFilterEnabled: function(data){return ko.computed(function(){ return huit_neuf_this.isBrandFilterEnabled(); }, this)},
            isSingleDateFilterEnabled: function(data){return ko.computed(function(){ return huit_neuf_this.isSingleDateFilterEnabled(); }, this)},
        };
    }

    public getViewModelForRequest(){

        return {
            reportFilter: this.getTemplateViewModel().reportFilter.selectedOption,
            filterDate: this.getTemplateViewModel().filterDate,
            startDate: this.getTemplateViewModel().datesFilter.startDate,
            endDate: this.getTemplateViewModel().datesFilter.endDate,
            reportPath: this.getTemplateViewModel().reportPath,
            countriesFilter: this.getTemplateViewModel().countriesFilter.selectedOption,
            brandsFilter: this.getTemplateViewModel().brandsFilter.selectedOption,
        };
    }

    protected showCountries() {

        if (this.getTemplateViewModel().reportFilter.selectedOption() == "amazon affiliate report" || this.getTemplateViewModel().reportFilter.selectedOption() == "amazon onsite report") {

            return true;
        }else {

            return false;
        }
    }

    /**
     * Determines if the brand filter should be enabled.
     */
    protected isBrandFilterEnabled(){

        const reports = [

            'amazon affiliate report',
            'amazon onsite report',
            'netline report',
            'sponsored direct report',
            'stackmedia report',
            'disqus report',
        ];

        return (reports.indexOf(this.getTemplateViewModel().reportFilter.selectedOption()) > -1);
    }

    /**
     * Determines if the date filter should be enabled.
     */
    protected isSingleDateFilterEnabled(){

        const reports = [

            "netline report",
            "sponsored direct report",
            "stackcommerce report",
            "disqus report",
        ];

        return (reports.indexOf(this.getTemplateViewModel().reportFilter.selectedOption()) > -1);
    }

    public setBrands(brands: Array<any>): void {

        this.brandsFilter.setOptions(brands);
        this.brandsFilter.setLabel("Brand");

    }

    public setCountries(countries: Array<any>): void {

        this.countriesFilter.setOptions(countries);
        this.countriesFilter.setLabel("Geo");

    }

    protected onClickImport(){

        if (!this.isFileUploadMissing() ) {
            this.caller.importReport();
        }
    }

    public disableImport() {

        return this.isFileUploadMissing() || this.isReportFilterMissing();
    }

    public isFileUploadMissing() {

        return this.getTemplateViewModel().reportPath() == null;
    }

    public isReportFilterMissing() {

        return this.getTemplateViewModel().reportFilter.selectedOption() == "";
    }

    public buildDatePickerCalendar(){

        this.filterDate.buildCalendarWithoutTime();
        this.datesFilter.buildCalendar();
    }

    public getSelectedReport() {
        return this.getTemplateViewModel().reportFilter.selectedOption();
    }
    public setCountryList(countries) {
        this.getTemplateViewModel().countryList(countries);
    }
    public getCountryList() {
        return this.getTemplateViewModel().countryList();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/dataImport_template.ts